import React, { useEffect, useState } from "react";
import { Box } from "@mui/material";
import { ResourceLinks } from "../../../../constants";
import { makeArrayRandom } from "../../../../utils/learner";
import { useSelector } from "../../../../store";

export default function WebSelectSentence({ question, onAnswer = () => {} }) {
    const questionData = question;
    const learnerState = useSelector((state) => state.learner || {});
    const data = learnerState?.details?.testLevel === "vfh" ? questionData?.vfh : questionData?.acsf4;
    const imagesResources = ResourceLinks.llnQuizImage;

    const [availableChoices, setAvailableChoices] = useState(data.choices);
    const [selectedOptions, setSelectedOptions] = useState({});
    const [isOptionRandom, setIsOptionRandom] = useState(false);

    // every time question change we will set to reset needed to reset
    useEffect(() => {
        setAvailableChoices(data.choices);
        setSelectedOptions({});
        setIsOptionRandom(false);
    }, [question,
        data.choices,
    ]);

    useEffect(() => {
        const canProceed = Object.keys(selectedOptions).length > 0;
        onAnswer({
            canProceed,
            answer: selectedOptions,
        });

    }, [selectedOptions, onAnswer]);

    const handleOptionClick = (option, key) => {
        setIsOptionRandom(true);
        const currentSelectedOptions = {...selectedOptions};
        currentSelectedOptions[key] = option;
        setSelectedOptions(currentSelectedOptions);
    };

    return (
        <Box
            sx={{
                position: "relative",
                fontWeight: "bold",
                textAlign: "left",
                width: data.mainDivWidth,
                fontSize: "28px",
                paddingTop: "100px"
            }}
        >
            {availableChoices.map((choice, index) => (
                <Box key={index}
                    sx={{
                        marginTop: "1em",
                        marginBottom: "1em",
                    }}
                >
                    {choice.children.map((row, rowIndex) => {
                        const type = typeof row;

                        let options = null;
                        if (type === "object") {
                            options = !isOptionRandom ? makeArrayRandom(row.options) : row.options;
                        }

                        return (
                            <React.Fragment key={rowIndex}>
                                {/* If String */}
                                {(type === "string") &&
                                    <React.Fragment>{row}</React.Fragment>
                                }
                                {/* If Object we will show the choice */}
                                {(type === "object") &&
                                    (
                                        <Box sx={{
                                            marginLeft: "5px",
                                            marginTop: "5px",
                                            display: "inline-block",
                                            fontWeight: "bold",
                                            textAlign: "left",
                                            fontSize: "28px",
                                        }}>
                                            {options.map((option, optionIndex) => (
                                                <span key={optionIndex} 
                                                    style={{
                                                        width: "auto",
                                                        height: "auto",
                                                        padding: "0px 5px",
                                                        marginRight: "5px",
                                                        borderBottomWidth: "5px",
                                                        display: "inline-table",
                                                        cursor: "pointer",
                                                        userSelect: "none",
                                                        fontWeight: "bold",
                                                        textAlign: "center",
                                                        fontSize: "28px",
                                                        backgroundColor: typeof selectedOptions[row.stateKey] !== "undefined" && selectedOptions[row.stateKey] === option ? "#afe23e" : "#dadada",
                                                        borderBottom: typeof selectedOptions[row.stateKey] !== "undefined" && selectedOptions[row.stateKey] === option? "10px solid #639729" : "10px solid #808080",
                                                        
                                                    }}
                                                    onClick={() => { handleOptionClick(option, row.stateKey) }}
                                                >{option}</span>
                                            ))}
                                        </Box>
                                    )
                                }
                            </React.Fragment>
                        )
                    })}
                </Box>
            ))}
            <Box component="img" 
                src={`${imagesResources}${data.image}`}
                sx={{
                    position: "absolute",
                    right: "0px",
                    top: "0px",
                }}
            />
        </Box>
    );
};
